import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Settings as SettingsIcon } from 'lucide-react';
import { loadUserState } from '../lib/user-state';
const NAV_LINKS = [
    {
        to: '/',
        matchPrefixes: ['/'],
        labelKey: 'common:nav.tab_today',
        ariaKey: 'common:nav.tab_today_aria',
    },
    {
        to: '/library',
        matchPrefixes: ['/library', '/play'],
        labelKey: 'common:nav.tab_library',
        ariaKey: 'common:nav.tab_library_aria',
    },
    {
        to: '/profile',
        matchPrefixes: ['/profile'],
        labelKey: 'common:nav.tab_profile',
        ariaKey: 'common:nav.tab_profile_aria',
    },
];
export function isTopNavLinkActive(pathname, link) {
    if (link.to === '/')
        return pathname === '/';
    return link.matchPrefixes.some((p) => pathname === p || pathname.startsWith(p + '/'));
}
export const TOP_NAV_LINKS = NAV_LINKS;
function getInitials(displayName) {
    if (!displayName || displayName.trim().length === 0)
        return 'VK';
    const parts = displayName.trim().split(/\s+/);
    if (parts.length === 1)
        return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
export function TopNav() {
    const { t } = useTranslation('common');
    const location = useLocation();
    const userState = loadUserState();
    const initials = getInitials(userState.profile.displayName);
    return (_jsx("header", { className: "\n        sticky top-0 z-40\n        bg-cyan-surface\n        border-b border-cyan-border-faint\n        pt-[env(safe-area-inset-top)]\n      ", "data-testid": "top-nav", children: _jsxs("div", { className: "mx-auto flex h-topbar w-full max-w-[1280px] items-center justify-between gap-6 px-8", children: [_jsxs(Link, { to: "/", "aria-label": t('nav.brand_aria', { defaultValue: 'LaBrain — Accueil' }), className: "\n            flex items-center gap-2\n            font-display text-[18px] font-medium tracking-cy-display\n            text-cyan-text transition active:scale-[0.98]\n            hover:text-cyan-core\n          ", children: [_jsx("span", { "aria-hidden": true, className: "block h-2 w-2 bg-cyan-network" }), _jsx("span", { children: t('nav.brand', { defaultValue: 'LaBrain' }) })] }), _jsx("nav", { "aria-label": t('nav.top_nav_aria', { defaultValue: 'Navigation principale' }), className: "flex items-center gap-1", children: _jsx("ul", { className: "flex items-center gap-1", children: NAV_LINKS.map((link) => {
                            const active = isTopNavLinkActive(location.pathname, link);
                            return (_jsx("li", { className: "relative", children: _jsxs(NavLink, { to: link.to, "aria-label": t(link.ariaKey), "aria-current": active ? 'page' : undefined, className: `
                      relative flex h-9 items-center px-4
                      font-display text-[14px] font-medium tracking-[-0.02em]
                      transition
                      ${active
                                        ? 'text-cyan-core'
                                        : 'text-cyan-text-secondary hover:text-cyan-core'}
                    `, children: [t(link.labelKey), active ? (_jsx("span", { "aria-hidden": true, className: "\n                          absolute bottom-0 left-1/2 h-[2px] w-8 -translate-x-1/2\n                          bg-cyan-network\n                        " })) : null] }) }, link.to));
                        }) }) }), _jsxs("div", { className: "flex items-center gap-2", children: [_jsx(Link, { to: "/settings", "aria-label": t('nav.settings_aria'), className: "\n              flex h-9 w-9 items-center justify-center\n              text-cyan-text-secondary transition active:scale-[0.94]\n              hover:text-cyan-core\n            ", children: _jsx(SettingsIcon, { size: 18, strokeWidth: 1.6, "aria-hidden": true }) }), _jsx(Link, { to: "/profile", "aria-label": t('nav.profile_aria'), className: "\n              flex h-9 w-9 items-center justify-center\n              bg-cyan-core text-cyan-surface\n              font-display text-[12px] font-medium tracking-[-0.02em]\n              transition active:scale-[0.96]\n            ", children: _jsx("span", { "aria-hidden": true, children: initials }) })] })] }) }));
}
//# sourceMappingURL=TopNav.js.map